import {
  id,
  Identifiable,
  List,
  Project,
  resource,
  Resource,
  task,
  Task,
} from "@planzone/dto";

type TimeRecord = {
  date: number;
  month: number;
  year: number;
  timeSpent: number;
  resource: Identifiable<Resource>;
  task: Identifiable<Task>;
  attributes?: { [key: string]: string };
  recordingDay?: string;
};

type SpentTime = {
  date: string;
  time: number;
  isAvailable: boolean;
};

type TimeSheetList = Omit<Identifiable<List>, "tasks" | "subLists"> & {
  project: Identifiable<Project>;
  spentTimes: SpentTime[];
  nbrAllocatedHours: number;
  totalOfSpentTime: number;
  totalOfSpentTimeInWeek: number;
  totalOfRemainingTime: number;
  subLists: TimeSheetList[];
  percentComplete: number;
  tasks: (Identifiable<Task> & {
    spentTimes: SpentTime[];
    nbrAllocatedHours: number;
    totalOfSpentTime: number;
    totalOfSpentTimeInWeek: number;
    totalOfRemainingTime: number;
    timeRecords: Identifiable<TimeRecord>[];
    taskResourceLatestRecord: string;
    taskResourceLatestRecordingDay: string;
    resourcePercentComplete: number;
  })[];
};

type TimeSheet = {
  spentTimes: SpentTime[];
  resources: (Identifiable<Resource> & {
    percentCompletion: number;
    spentTimes: SpentTime[];
    totalOfAllocatedHours: number;
    totalOfSpentTime: number;
    totalOfSpentTimeInWeek: number;
    totalOfRemainingTime: number;
    lists: TimeSheetList[];
  })[];
};

const timeSheet: TimeSheet = {
  spentTimes: [],
  resources: [],
};

const timeRecord: TimeRecord = {
  date: 0,
  month: 0,
  year: 0,
  timeSpent: 0,
  resource: { ...resource, uuid: id },
  task: { ...task, uuid: id },
};

export type { TimeSheet, TimeRecord };

export { timeRecord, timeSheet };
